// Module
var code = `<form-section form-title="\$ctrl.quotaTitle">
  <div class="form-column">
    <div ng-repeat="quota in \$ctrl.quotas">
      <form-section-field
        field-title="[(quota.period | prettyEnum), (quota.type | prettyEnum | lowercase), 'amount quota (0 for unlimited)'].join(' ')">
        <cash ng-model="quota.cashQuota"
              min="0"
              required>
        </cash>
      </form-section-field>
      <form-section-field
        field-title="[(quota.period | prettyEnum), (quota.type | prettyEnum | lowercase), 'count quota (0 for unlimited)'].join(' ')">
        <input type="number"
               ng-model="quota.countQuota"
               min="0"
               max="2147483647"
               step="1"
               required/>
      </form-section-field>
    </div>
  </div>
</form-section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/agent-banking/quota/transaction-quota.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;